'use client';
import DynamicImage from '@/components/DynamicImage';
import { motion } from 'framer-motion';
import { useEffect, useState } from 'react';
// import { AnimatedButton } from './common/AnimatedButton';
// import RegisDialog from './regisDialog';

const Footermobile = () => {
  return (
    <section className="w-full bg-[#121212] text-[#fff]">
      <div
        className="bg-[url('https://osscdn.weiyouzhihui.com/editorVideo/1736478704966/image%201941%402x.png')] w-full h-[110px] bg-top bg-no-repeat text-center py-[20px] px-[26px]"
        style={{ backgroundSize: '100% 100%' }}
      >
        <p className="text-[16px]">全链路营销解决方案</p>
        <p className="text-[13px] mt-[4px]">
          实时在线解答，降低企业运营成本；强大的技术保障，高效响应客户需求
        </p>
      </div>
      <div className="flex justify-between px-[20px] py-[16px] items-center border-b-[1px] border-[rgba(255,255,255,0.3)]">
        <DynamicImage
          src="https://osscdn.weiyouzhihui.com/editorVideo/1736479005763/Frame%201312321269%402x.png"
          className="w-[142px] h-[37px]"
        ></DynamicImage>
        <div className="flex flex-col items-center">
          <DynamicImage
            src="https://osscdn.weiyouzhihui.com/mall/goods/1758599699501/0%5B1%5D.png"
            className="w-[80px] h-[80px]"
          ></DynamicImage>
          <p className="text-[12px] text-[#ffffff]">立即扫码咨询</p>
        </div>
      </div>
      <p className="px-[15px] py-[10px] text-[12px] text-center">
        深圳市南山区粤海街道滨海社区高新南十道81、83、85号深圳市软件产业基地1栋A701-5
      </p>
    </section>
  );
};

export default Footermobile;
